import React from 'react';

/**
 * Show/hide password icon.
 *
 * Replaces the 👁 / 🙈 emoji that used to sit in these fields: emoji render
 * differently on every platform, sit on their own baseline, and read as
 * decoration rather than a control. A stroked line icon inherits `currentColor`
 * and the surrounding font size, so it matches whatever it is dropped into.
 *
 * `off` draws the same eye with a slash, which is the near-universal convention
 * for "click to reveal" — users recognise it without a tooltip.
 */
export function EyeIcon({ off = false, size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      style={{ display: 'block' }}
    >
      {off ? (
        <>
          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
          <line x1="1" y1="1" x2="23" y2="23" />
        </>
      ) : (
        <>
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </>
      )}
    </svg>
  );
}
